import ReactStrapTable from 'components/reactStrapTable';
import React, { useState,useEffect } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Card, CardBody, Col, Container, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';


let tableDataBackup = [
    {
        chainPharmacy:"123445",
        pharmacy:"123445",
        npi:"123445",
        ncpdPandNABP:"123445",
        pharmacyAddress:"123445",
        pharmacyLiveDate:"123445",
        pharmacyTerminationDate:"123445",
        claimsProcessDate:"123445",

    }
];

const SearchOrderDrawer = (props) => {
    debugger;
    // const {
       
    //     manvalConfigedit,
    //     manvalConfig,
    //     manvalPharmacy,
    // } = props;
    const {orgId,rowData}=props
    // const { poNumber } = rowData;
    const API = useAxios();
    const {
        states: { reviewOrder },
        setStates,
    } = useContextService();
      const { search, coveredEntity, searchTerms, claimStatusID } = reviewOrder; 
      const [data,setData] = useState([]);
      const[totalitem,setTotalItem] = useState(0);
    const [tableData, setTableData] = useState(tableDataBackup);
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    const handleConfig = async (rowData) => {
         await manvalConfig();

    }
    const handelAddCoveredEntity = async (rowData) => {
        await manvalPharmacy();

   }
    const handleEditConfig = async () => {
        await manvalConfigedit();
    }
    const renderEditButton = () => {
         if (hasPermission('ED'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => handleEditConfig()}
                title='Edit Covered Entity'

            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    useEffect(() => {
   
        fetchPOOrderItemDetails();
      
  
    }, []);

    const fetchPOOrderItemDetails = async () => {
        debugger;
       let payload = {};
       payload.CurrentPage=1,
       payload.pageSize=10,
       payload.orderBy="poid",
       payload.order="desc",
       payload.filters=[],
       payload.AccumulatorIDs=[1],
       payload.AccountTypeID=0,
       payload.POStatusID = 0,
       payload.Invoice = ""
    
        try {
            const  {data} = await API.post(`SBTenant/${orgId.tenantID}/PurchaseOrder/PODetails/${rowData}`,payload,
                { hasDefaultURL: true,}
            )
          if (data) {
            setData(data.items);
            setTotalItem(data.totalRecords);
          }
        } catch (error) {
        
        }
      };
      const handelNDCdetails=async(rowData)=>{
            toggle(rowData)
try{

}
catch(error){
    
}
      }

    const cellRenderLink = (rowData) => {
        // if (hasPermission('VWPO')) {
          return (
            <span
              className='text-decoration-underline d-inline-block cursor-pointer'
              onClick={() => handelNDCdetails(rowData)}
            >
              {rowData}
            </span>
          );
        // }
      };
    const renderConfigButton = () => {

        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => handleConfig()}
            title='Client Configuration'

        >
            <HoverImage
                src={ConfigIcon}
                hoverSrc={ConfigIconHover}
                alt='' />
        </Button>
    }


    const cellRenderEdit = (rowData) => {
        return (
            <div className='d-flex align-items-center'>
                {renderEditButton()}
                {/* {renderConfigButton(rowData)} */}
                {/* {renderCommentsButton(rowData)} */}
                {/* {renderViewButton(rowData)} */}
            </div>
        );
    };
    const SelectButton = () => {
        // if (hasPermission('EDT'))
            return <Input 
        type="checkbox"
        className='m-auto'
        >

        </Input>
    }
    const CellSelectall = (rowData) => {
        return (
            <div className='d-flex align-items-center'>
                {SelectButton()}
                {/* {renderConfigButton(rowData)} */}
                {/* {renderCommentsButton(rowData)} */}
                {/* {renderViewButton(rowData)} */}
            </div>
        );
    };
    const handleExport = async () => {
        const { access_token } =
            JSON.parse(localStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
        onExport(action, initialFilters);
    };
    let mainCol = [
        {
            dataField: 'edit',
            text: 'Options',
             cellRenderer: (rowData) => cellRenderEdit(rowData),
            width: 80,
            show: false,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: 'ndc',
            text: 'NDC',
            cellRenderer: (row) => cellRenderLink(row.ndc),
            width: 80,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },

        {
            dataField: 'drugName',
            text: 'Drug Name',
            sort: false,
            width: 240,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.drugName),
        },
        {
            dataField: 'itemStatus',
            text: 'Item Status',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.itemStatus),
        },
        {
            dataField: 'qtyOrder',
            text: 'Qty. Ordered',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.qtyOrder),
        },
        {
            dataField: 'qtyAck',
            text: 'Qty Ack',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.qtyAck),
        },
        {
            dataField: 'qtyInvoiced',
            text: 'Qty Invoiced',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.qtyInvoiced),
        },
        {
            dataField: 'qtyReceived',
            text: 'Qty Received',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.qtyReceived),
        },
        {
            dataField: 'dateAck',
            text: 'Date Ack',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.dateAck),
        
        },
        {
            dataField: 'invoicedDate',
            text: 'Invoiced Date',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.invoicedDate),
        },
        {
            dataField: 'pkgPrice',
            text: 'Pkg Price',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => currencyFormat(row.pkgPrice),
        },
        {
            dataField: 'ackPkgPrice',
            text: 'Ack Pkg Price',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => currencyFormat(row.ackPkgPrice),
        },
        {
            dataField: 'invoicedPkgPrice',
            text: 'Invoiced Pkg Price',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => currencyFormat(row.invoicedPkgPrice),
        },
        {
            dataField: 'totalOrdPrice',
            text: 'Total Ord Price',
            sort: false,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => currencyFormat(row.totalOrdPrice),
        },
        {
            dataField: 'totalAckPkgPrice',
            text: 'Total Ack Pkg Price',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => currencyFormat(row.totalAckPkgPrice),
        },
        {
            dataField: 'totalInvoicedPrice',
            text: 'Total Invoiced Price',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => currencyFormat(row.totalInvoicedPrice),
        },
        {
            dataField: 'invoiced',
            text: 'Invoice #',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => currencyFormat(row.invoiced),
        },
       

    ];
    let modalmainCol = [
        {
            dataField: 'chainPharmacy',
            text: 'Account Type',
            cellRenderer: (row) => cellRendererCheck(row.chainPharmacy),
            width: 80,
            show: false,
            disabled: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: 'chainPharmacy',
            text: 'Account Type',
            cellRenderer: (row) => cellRendererCheck(row.chainPharmacy),
            width: 80,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },

        {
            dataField: 'chainPharmacy',
            text: 'Invoiced Date',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.chainPharmacy),
        },
        {
            dataField: 'pharmacy',
            text: 'Wholesaler',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.pharmacy),
        },
        {
            dataField: 'npi',
            text: 'POID',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.npi),
        },
        {
            dataField: 'ncpdPandNABP',
            text: 'Invoiced Qty',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.ncpdPandNABP),
        },
        {
            dataField: 'pharmacyAddress',
            text: 'Pkg Price',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.pharmacyAddress),
        },
        {
            dataField: 'pharmacyLiveDate',
            text: 'Total Price',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.pharmacyLiveDate),
        },
       
       

    ];
  return (
    
    <div className='py-2'>
        
                <Row>
                <h4 className='f-15 text-primary font-weight-700'>Purchase Order </h4>

                <Col md="4">
                    <p className="m-0 f-14 mt-3">PO # :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"43454"}</p>
                </Col>
               
                <Col md="4">
                    <p className="m-0 f-14 mt-3">PO Date : </p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"24/09/2024"}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">PO Status : </p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"Order Open"}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Covered Entity : </p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"Candler County Hospital/CAH111334-00 "}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Accumulator : </p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"Candler County Hospital/CAH111334-00 "}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Wholesaler : </p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"ABC"}</p>
                </Col>
               
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Total Order Price : </p>
                    <span className="m-0 f-14 font-weight-500 mt-1" ></span>

                    <p className="m-0 f-14 font-weight-500 mt-1">{"$1234454"}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Total Invoiced Price : </p>
                    <span className="m-0 f-14 font-weight-500 mt-1" ></span>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"$234547"}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Account Type : <span className="m-0 f-14 font-weight-500 mt-1"> {"340B"}</span></p>
                </Col>
               


            </Row>
            <hr></hr>
              <div
            className='table-card scroll-table position-relative border-0 rounded pt-0'
            fixed-height={tableData.length > 0 ? 'fixed-height' : 'default'}
        >
            <ReactStrapTable
                id='configuration-table'
                height={550}
                fixedColumn
                width={1200}
                // reset={reset}
                data={data}
                columns={mainCol}
                // add={"Upload"}
                // addbutton={true}
                // // handelAddCoveredEntity={handelAddCoveredEntity}
                  onExport={handleExport}
                // filters={2}
                 totalRecords={1}
                 pageSize={20}
                 currentPage={1}
                // handleSort={onHandleSort}
                // onPageChange={onHandlePageChange}
                // onPageSizeChange={onPageSizeChange}
                // onFilterCancel={handleFilterCancel}
                // onSearchColumnFilters={handleSearchColumnFilters}
                // hasExportPermission={hasExportPermission}
            />
        </div>
        <Modal isOpen={modal} fade={false} toggle={toggle} className={props.className} style={{maxWidth:"90%"}}>
        <ModalHeader toggle={toggle}><h5 className="f-15 text-primary font-weight-700 mt-2">
        NDC Historical Purchase Details
    </h5></ModalHeader>
        <ModalBody>
        <Row className='m-auto'>

                <Col md="4" className='d-flex'>
                    <p className="m-0 f-14 mt-3">NDC :</p>
                    <p className="m-0 f-14 font-weight-500 mt-3" style={{marginLeft:"5px"}}>{"00000003212"}</p>
                </Col>
               
                <Col md="4" className='d-flex'>
                    <p className="m-0 f-14 mt-3">Drug Name: </p>
                    <p className="m-0 f-14 font-weight-500 mt-3">{"STERILEWIPE LP 12X12 BG/100"}</p>
                </Col>
               
               


            </Row>
            <hr/>
            <div
            className='table-card scroll-table position-relative border-0 rounded pt-0'
            fixed-height={tableData.length > 0 ? 'fixed-height' : 'default'}
        >
            <ReactStrapTable
                id='ndc-historical-table'
                height={550}
                fixedColumn
                width={1200}
                // reset={reset}
                data={tableData}
                columns={modalmainCol}
                
                // handelAddCoveredEntity={handelAddCoveredEntity}
                //   onExport={handleExport}
                // filters={2}
                 totalRecords={totalitem}
                // pageSize={20}
                 currentPage={1}
                // handleSort={onHandleSort}
                // onPageChange={onHandlePageChange}
                // onPageSizeChange={onPageSizeChange}
                // onFilterCancel={handleFilterCancel}
                // onSearchColumnFilters={handleSearchColumnFilters}
                // hasExportPermission={hasExportPermission}
            />
        </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
                
          
    </div>
  )
}

export default SearchOrderDrawer
